import { cn } from "@suraasa/placebo-ui"
import { ReactNode } from "react"

type Props = {
  className?: string
  children: ReactNode
}

const PageContainer = (props: Props) => {
  return (
    <div className={cn("mx-auto max-w-[1280px] px-2", props.className)}>
      {props.children}
    </div>
  )
}

export default PageContainer
